module.exports = "https://coinrabbit.io/_next/static/images/step-3-e839ba870acea81d72180e5d9f3f3270.svg";